// extracted by mini-css-extract-plugin
module.exports = {"waitAndAppear":"SpinnerAnimation_waitAndAppear__3_938","fadein":"SpinnerAnimation_fadein__HBKA_"};